import * as React from "react";

import { Button, Modal } from "semantic-ui-react";

export interface TaskConfirmationActionProps {
    openModal: boolean;
    onCancel: () => void;
    onConfirm: () => void;
    title: string;
    content: string;
}

const TaskConfirmationAction: React.FC<TaskConfirmationActionProps> = ({ onCancel, onConfirm, openModal, title, content }) => {
    const onCancelClick = () => {
        onCancel();
    };

    const onConfirmClick = () => {
        onConfirm();
    };

    return (
        <Modal size="tiny" open={openModal}>
            <Modal.Header content={title} />
            <Modal.Content>
                <p>{content}</p>
            </Modal.Content>
            <Modal.Actions>
                <Button content="Confirm" onClick={onConfirmClick} />
                <Button content="Cancel" onClick={onCancelClick} />
            </Modal.Actions>
        </Modal>
    );
};

export {
    TaskConfirmationAction
};
